$ = require('jquery')
ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Auth = require 'db/auth'
Board = require 'models/board'
Card = require 'models/card'
List = require 'models/list'
ModelLoader = require 'db/model-loader'
moment = require 'moment'
Organization = require 'models/organization'
Promise = require 'bluebird'
React = require 'react'
_ = require 'underscore'
t = require('views/internal/recup-with-helpers')('home')
trackUe = require 'debug/trackUe'
DueDate = require 'views/home/due-date'
StickyBoxWaitForMount = require 'views/lib/sticky-box-wait-for-mount'
{ ContentSkeleton } = require './presentational/content-skeleton'
{ TeamCardsDueSection } = require './presentational/team-cards-due-section'
{ getScrollParent } = require('common/lib/dom/get-scroll-parent')

module.exports = class TeamCardsDueContainer extends React.Component
  displayName: 'TeamCardsDueContainer'

  constructor: (props) ->
    super props

    @unresolvedPromises = new Set()
    @fetchDueDateCards = @fetchDueDateCards.bind(@)
    @setGroupRef = @setGroupRef.bind(@)
    @onClickGroup = @onClickGroup.bind(@)

    @state = {
      dueDateCards: []
      loading: true
      selectedGroup: 'overdue'
    }

    @groupRefs = {}

  componentDidMount: ->
    @cancelOnUnmount(new Promise((resolve) -> ModelLoader.waitFor('boardsData', resolve))).then =>
      @fetchDueDateCards().then (dueDateCards) =>
        @setState
          dueDateCards: dueDateCards
          loading: false
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e
        @setState
          loading: false

  componentWillUnmount: ->
    @unresolvedPromises.forEach((promise) -> promise.cancel())

  cancelOnUnmount: (promise) =>
    promise.cancellable()
    @unresolvedPromises.add(promise)
    promise.then => @unresolvedPromises.delete(promise)

    return promise

  setGroupRef: (groupName, groupRef) ->
    @groupRefs[groupName] = groupRef

  onClickGroup: (groupName) ->
    { orgId } = @props

    method = "by clicking scroll to #{groupName} button in due dates feed when filtered by team"
    context = { teamId: orgId }

    trackUe('home', 'scrolls to section', 'due dates feed', '', 'on team cards tab', method, context)

    @setState(selectedGroup: groupName)
    @scrollIntoView(@groupRefs[groupName])

  scrollIntoView: (el) ->
    if !el
      return true

    $(getScrollParent(el)).animate({
      scrollTop: el.offsetTop - 8,
    })

  fetchDueDateCards: ->
    { modelCache, orgId } = @props
    idMember = Auth.me().id

    @cancelOnUnmount(ModelLoader.loadOrgMemberCardData(orgId, idMember))
      .then (response) =>
        dueDateCards = response.map (card) =>
          list = modelCache.get('List', card.get('idList'))
          board = modelCache.get('Board', card.get('idBoard'))
          org = modelCache.get('Organization', orgId)

          return {
            id: card.id
            card: modelCache.get('Card', card.id)
            dueComplete: card.get('dueComplete')
            dueDate: card.get('due')
            list
            board
            org
          }

        return _.sortBy(dueDateCards.filter((dueDateCard) => dueDateCard.dueDate && !dueDateCard.dueComplete), 'dueDate')

      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e

        console.error e
        []

  removeDueDateCard: (dueDateId) =>
    @setState (prevState) ->
      dueDateCards: prevState.dueDateCards.filter((dueDateCard) -> dueDateCard.id != dueDateId)

  renderDueDate: (dueDateCard) =>
    { id, card, list, board, org } = dueDateCard
    { modelCache } = @props

    React.createElement DueDate, {
      board
      card
      id
      key: id
      list
      modelCache
      org
      @removeDueDateCard
    }

  getDueDateOf: (dueDateCard) =>
    return (dueDateCard.card.getDueDate() || new Date()).getTime()

  render: t.renderable ->
    { orgName, orgId } = @props
    { dueDateCards, loading, selectedGroup } = @state

    if loading
      t.div '.home-due-dates-loading-container', =>
        t.tag ContentSkeleton
    else
      t.div '.home-due-dates-container', =>
        t.tag TeamCardsDueSection, {
          dueDateCards
          @getDueDateOf
          now: moment()
          @onClickGroup
          @renderDueDate
          selectedGroup
          @setGroupRef
          StickyBoxWaitForMount
        }



// WEBPACK FOOTER //
// ./app/scripts/views/home/team-cards-due-container.coffee